export default __webpack_public_path__ + "static/media/board.min.64bd1cd0.png";